import { render } from "./Summary.vue?vue&type=template&id=6a18b4e2"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\sonic\\renault\\new_resources\\renault_configurator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__